import React, { useEffect, useState, useContext } from "react";
import { useParams, useLocation } from "react-router-dom";
import { APIServices } from "../helpers/APIServices";
import dayjs from "dayjs";
import LineChartForNormalQT from "../Components/LineChartForNormalQT";
import DateTime from "../Components/DateTime";
import Button from "@mui/material/Button";
import { UserContext } from "../Layout";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import TableReportNormalQTWithActual from "./../Components/TableReportNormalQTWithActual";
import SimpleBackdrop from "../Components/Backdrop";
import { getImageUrl } from "../helpers/common";

const headers = [
  // {
  //   name: "ID",
  // },
  {
    name: "No.",
  },
  {
    name: "create date",
  },
  // {
  //   name: "shift",
  // },
  {
    name: "job No.",
  },
  {
    name: "actual",
    col: [
      {
        name: "No.1",
      },
      {
        name: "No.2",
      },
      {
        name: "No.3",
      },
    ],
  },
  {
    name: "average",
  },

  {
    name: "inspector",
  },
  {
    name: "reviewer",
  },
];

const PerPathNormalQTWithActual = () => {
  const defaultDateTime = {
    start: `${dayjs().subtract(1, "d").format("YYYY-MM-DD")} 00:00:00`,
    end: `${dayjs().format("YYYY-MM-DD")} 23:59:59`,
  };
  const param = useParams();
  const [reportData, setReportData] = useState([]);
  const [dataAverage, setDataAverage] = useState([]);
  const [startDate, setStartDate] = useState({
    error: false,
    value: defaultDateTime.start,
  });
  const [endDate, setEndDate] = useState({
    error: false,
    value: defaultDateTime.end,
  });

  const [loading, setLoading] = useState(false);

  //Chok add Filter NG/ALL/Ok
  // const [status, setStatus] = React.useState("ALL");

  // const handleChangeStatus = (event) => {
  //   setStatus(event.target.value);
  // };

  const [checkDate, setCheckDate] = useState({
    error: false,
    message: "end date should more than start date",
  });
  
  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelecteds = reportData.slice(0, 30).map((n) => n.id);
      setSelectedRows(newSelecteds);
      return;
    }
    setSelectedRows([]);
  };

  const handleSelectFirst30 = () => {
    const newSelecteds = reportData.slice(0, 30).map((n) => n.id);
    setSelectedRows(newSelecteds);
  };

  const handleSelectRow = (event, id) => {
    const selectedIndex = selectedRows.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      if (selectedRows.length >= 30) {
        alert("สามารถเลือกข้อมูลเพื่อ Export ได้สูงสุด 30 รายการเท่านั้น");
        return;
      }
      newSelected = newSelected.concat(selectedRows, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelected = newSelected.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      );
    }

    setSelectedRows(newSelected);
  };

  const [part, setPart] = useState({});
  const user = useContext(UserContext);
  let location = useLocation();
  let locationArr = location.pathname.split("/").reverse();

  const findOnePart = async (startDate, endDate, status) => {
    if (!startDate && !endDate) {
      startDate = defaultDateTime.start;
      endDate = defaultDateTime.end;
    }
    setLoading(true);
    try {
      const partId = locationArr[4];
      const [responseFromFindOnePart, responseFromFindOneQuestion, paper] =
        await Promise.all([
          APIServices.findOnePart(partId),
          APIServices.findOneQuestion(param.id),
          APIServices.getPaper(startDate, endDate, partId, user),
        ]);

      const resultFromFindOnePart = responseFromFindOnePart?.data;
      const resultFromFindOneQuestion = responseFromFindOneQuestion?.data;
      const parts = resultFromFindOnePart?.data;
      let questionData = {
        question_name: null,
        spec_min: null,
        spec_max: null,
        specCount: null,
        formatTorelance: null,
        torelance1: null,
        torelance2: null,
        UCL_Xbar: null,
        CL_Xbar: null,
        LCL_Xbar: null,
      };

      if (parts?.attributes?.sub_categories?.data) {
        const subCats = parts.attributes.sub_categories.data;
        for (let i = 0; i < subCats.length; i++) {
          const subCatPerLoop = subCats[i];
          const questions = subCatPerLoop?.attributes?.questions?.data || [];
          const findQuestion = questions.find((qt) => {
            return qt.id === parseInt(param.id);
          });
          if (findQuestion) {
            questionData = {
              question_name: findQuestion.attributes?.question || null,
              spec_min: findQuestion.attributes?.spec_min || null,
              spec_max: findQuestion.attributes?.spec_max || null,
              specCount: findQuestion.attributes?.specCount || null,
              formatTorelance: findQuestion.attributes?.formatTorelance || null,
              torelance1: findQuestion.attributes?.torelance1 || null,
              torelance2: findQuestion.attributes?.torelance2 || null,
              UCL_Xbar: findQuestion.attributes?.UCL_Xbar || null,
              CL_Xbar: findQuestion.attributes?.CL_Xbar || null,
              LCL_Xbar: findQuestion.attributes?.LCL_Xbar || null,
            };
            break;
          }
        }
      }

      if (!questionData.question_name && resultFromFindOneQuestion?.data) {
        const qAttr = resultFromFindOneQuestion.data.attributes;
        questionData = {
          question_name: qAttr?.question || null,
          spec_min: qAttr?.spec_min || null,
          spec_max: qAttr?.spec_max || null,
          specCount: qAttr?.specCount || null,
          formatTorelance: qAttr?.formatTorelance || null,
          torelance1: qAttr?.torelance1 || null,
          torelance2: qAttr?.torelance2 || null,
          UCL_Xbar: qAttr?.UCL_Xbar || null,
          CL_Xbar: qAttr?.CL_Xbar || null,
          LCL_Xbar: qAttr?.LCL_Xbar || null,
        };
      }

      if (parts) {
        let image = "";
        if (parts?.attributes?.image?.data?.attributes?.url) {
          image = parts.attributes.image.data.attributes.url;
        } else if (parts?.attributes?.image?.data?.[0]?.attributes?.url) {
          image = parts.attributes.image.data[0].attributes.url;
        } else if (parts?.attributes?.image?.url) {
          image = parts.attributes.image.url;
        } else if (
          Array.isArray(parts?.attributes?.image) &&
          parts.attributes.image[0]?.url
        ) {
          image = parts.attributes.image[0].url;
        }

        setPart({
          part_name: parts.attributes?.part_name || "",
          part_code: parts.attributes?.part_code || "",
          part_image: image,
          customer: parts.attributes?.customer || "",
          ...questionData,
        });

        const result = paper?.data;
        if (result?.data) {
          const papers = result.data;
          let report = [];
          const arrAverage = [];
          let questionId;

          papers.forEach((paper) => {
            try {
              let realData,
                average = 0;
              const sub_categories = Array.isArray(
                paper?.attributes?.answer?.sub_categories,
              )
                ? paper.attributes.answer.sub_categories
                : [];

              let isSkip = false;
              sub_categories.forEach((sub_category) => {
                const questionsList = Array.isArray(sub_category?.questions)
                  ? sub_category.questions
                  : [];
                const realPaper = questionsList.find((p) => {
                  return p.questionId === parseInt(locationArr[0]);
                });

                if (realPaper) {
                  if (realPaper.skipQuestion) {
                    isSkip = true;
                    return;
                  }
                  realData = realPaper;
                  if (!questionId) {
                    questionId = realPaper.questionId;
                  }

                  if (Array.isArray(realPaper.actual) && realPaper.actual.length > 0) {
                    const actualInt = realPaper.actual
                      .map((actualLoop) => parseFloat(actualLoop))
                      .filter((val) => !isNaN(val));

                    if (actualInt.length > 0) {
                      const sumActual = actualInt.reduce((a, b) => a + b, 0);
                      average = parseFloat(
                        (sumActual / actualInt.length).toFixed(2),
                      );
                    }
                  }
                }
              });

              if (isSkip) {
                return;
              }

              const inspector =
                paper.attributes?.inspector_id?.data?.attributes?.name || "-";
              const checker =
                paper.attributes?.checker_id?.data?.attributes?.name || "-";

              if (realData !== undefined) {
                report.push({
                  id: paper.id,
                  createAt: dayjs(paper.attributes?.createdAt).format(
                    "YYYY-MM-DD HH:mm:ss",
                  ),
                  data: realData,
                  average: average.toFixed(2),
                  jobNo: paper.attributes?.jobNumber || "",
                  date: paper.attributes?.date || "",
                  time: paper.attributes?.time || "",
                  machineNo: paper.attributes?.machineNumber || "",
                  inspector: inspector,
                  checker: checker,
                  statusDelete: paper.attributes?.delete,
                });
                if (!isNaN(average)) {
                  arrAverage.push(average);
                }
              }
            } catch (error) {
              console.error("Error processing paper:", error);
            }
          });
          setReportData(report);
          setDataAverage(arrAverage);
        }
      }
    } catch (err) {
      console.error("Error in PerPathNormalQTWithActual findOnePart:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleOnChangeStartDate = (date, time) => {
    if (!date || !time) {
      setStartDate((prev) => ({
        ...prev,
        value: undefined,
      }));
      return;
    }
    const startDate = dayjs(`${date} ${time}`).format("YYYY-MM-DD HH:mm:ss");
    setStartDate((prev) => ({
      ...prev,
      value: startDate,
      error: false,
    }));
  };

  const handleOnChangeEndDate = (date, time) => {
    if (!date || !time) {
      setEndDate((prev) => ({
        ...prev,
        value: undefined,
      }));
      return;
    }
    const endDate = dayjs(`${date} ${time}`).format("YYYY-MM-DD HH:mm:ss");
    setEndDate((prev) => ({
      ...prev,
      value: endDate,
      error: false,
    }));
  };

  const handleSubmitSearch = async (startDate, endDate, status) => {
    if (!startDate.value) {
      setStartDate((prev) => ({
        ...prev,
        error: true,
      }));
      return;
    }
    if (!endDate.value) {
      setEndDate((prev) => ({
        ...prev,
        error: true,
      }));
      return;
    }
    if (
      dayjs(endDate.value).isBefore(startDate.value, "minute") ||
      dayjs(endDate.value).isSame(startDate.value, "minute")
    ) {
      setCheckDate((prev) => ({
        ...prev,
        error: true,
      }));
      setTimeout(() => {
        setCheckDate((prev) => ({
          ...prev,
          error: false,
        }));
      }, 2000);
      return;
    }
    setLoading(true);
    console.log(startDate.value, endDate.value, status);
    await findOnePart(startDate.value, endDate.value, status);
    setLoading(false);
  };

  useEffect(() => {
    findOnePart();
  }, []);

  useEffect(() => {
    console.log(reportData);
  }, [reportData]);

  // useEffect(() => {
  //   console.log(status);
  // }, [status]);
  return (
    <div>
      {/* <pre>{JSON.stringify(part)}</pre> */}
      {/* <div className="bg-black w960 h-40 flex justify-center items-center">
      <div className="py-2 px-4 bg-white rounded-full hover:bg-yellow-300 transition">
        Sawanon Wattanasit
      </div>
      </div> */}
      {/* <div className={`lg:flex lg:flex-row p-2 justify-center flex flex-col`}> */}
      <SimpleBackdrop open={loading} setOpen={setLoading} />

      <div
        className={`bg-white rounded-md drop-shadow py-2 px-4 lg:mt-0 lg:basis-1/2 lg:m-1 flex flex-row`}
      >
        <div className={`basis-1/2 `}>
          <div className="flex">
            <div className={`basis-1/2 text-gray-500`}>ID QT :</div>
            <div className={`basis-1/2 text-end`}>{part.part_name}</div>
          </div>
          <div className="flex">
            <div className={`basis-1/2 text-gray-500`}>Part name :</div>
            <div className={`basis-1/2 text-end`}>{part.part_name}</div>
          </div>
          <div className="flex mt-2">
            <div className={`basis-1/2 text-gray-500`}>Part No. :</div>
            <div className={`basis-1/2 text-end`}>{part.part_code}</div>
          </div>
          <div className="flex mt-2">
            <div className={`basis-1/2 text-gray-500`}>Characteristic :</div>
            <div className={`basis-1/2 text-end`}>{part.question_name}</div>
          </div>
          {part.spec_min && part.spec_max && (
            <div className="flex mt-2">
              <div className={`basis-1/2 text-gray-500`}>Specification :</div>
              <div className={`basis-1/2 text-end`}>
                {part.spec_min && (
                  <span className={``}>{`(Min) ${part.spec_min.toFixed(
                    2
                  )}`}</span>
                )}
                {part.spec_max && (
                  <span className={`ml-4`}>{`(Max) ${part.spec_max.toFixed(
                    2
                  )}`}</span>
                )}
              </div>
            </div>
          )}
          {part.specCount && (
            <div className="flex mt-2">
              <div className={`basis-1/2 text-gray-500`}>Spect-Count :</div>
              <div className={`basis-1/2 text-end`}>
                {part.specCount && (
                  <span className={``}>{`${part.specCount}`}</span>
                )}
              </div>
            </div>
          )}
          {part.torelance1 && (
            <div className="flex mt-2">
              <div className={`basis-1/2 text-gray-500`}>Torelance1 :</div>
              <div className={`basis-1/2 text-end`}>
                {part.torelance1 && (
                  <span className={``}>{`±${part.torelance1}`}</span>
                )}
              </div>
            </div>
          )}
          {part.torelance2 && (
            <div className="flex mt-2">
              <div className={`basis-1/2 text-gray-500`}>Torelance2 :</div>
              <div className={`basis-1/2 text-end`}>
                {part.torelance2 && (
                  <span className={``}>{`±${part.torelance2}`}</span>
                )}
              </div>
            </div>
          )}
          {part.UCL_Xbar && (
            <div className="flex mt-2">
              <div className={`basis-1/2 text-gray-500`}>
                Variable Control Chart :
              </div>
              <div className={`basis-1/2 text-end`}>
                {part.UCL_Xbar && (
                  <span
                    className={``}
                  >{`(UCL) ${part.UCL_Xbar} | (CL) ${part.CL_Xbar} | (LCL) ${part.LCL_Xbar}`}</span>
                )}
              </div>
            </div>
          )}
        </div>
        <div className={`flex justify-center items-center basis-1/2 m-1`}>
          {part.part_image ? (
            <img src={getImageUrl(part.part_image)} className=" object-contain h-[300px]" alt="part" />
          ) : (
            <div
              style={{ width: "6rem", height: "6rem" }}
              className="bg-gray-100 flex items-center justify-center rounded-lg"
            >
              <NoPhotographyIcon />
            </div>
          )}
        </div>
      </div>
      {/* </div> */}
      <div>
        <div
          className={` md:basis-1/2 flex flex-row justify-center items-center mt-4 md:ml-2`}
        >
          {checkDate.error && (
            <div
              className={`bg-red-500 py-2 px-4 text-white absolute rounded-md -bottom-10`}
            >
              {checkDate.message}
            </div>
          )}
          <div className={`${startDate.error && `bg-red-300 rounded`}`}>
            <DateTime
              value={startDate.value}
              autoFocus={startDate.error}
              label={`Start date`}
              onChange={handleOnChangeStartDate}
            />
          </div>
          <div className={`${endDate.error && `bg-red-300 rounded`}`}>
            <DateTime
              value={endDate.value}
              autoFocus={endDate.error}
              label={`End date`}
              onChange={handleOnChangeEndDate}
            />
          </div>
          {/* <FormControl variant="standard" sx={{ mt: 1, ml: 2, minWidth: 120 }}>
            <InputLabel id="status-label">Status</InputLabel>
            <Select
              defaultValue="ALL"
              value={status}
              label="Status"
              labelId="status-label"
              onChange={handleChangeStatus}
            >
              <MenuItem value={"ALL"}>All</MenuItem>
              <MenuItem value={"OK"}>OK</MenuItem>
              <MenuItem value={"NG"}>NG</MenuItem>
            </Select>
          </FormControl> */}
          <div className="mt-4 ml-4 flex gap-2">
            <Button
              className="bg-colorMain hover:bg-orangeCustom"
              variant="contained"
              onClick={() => handleSubmitSearch(startDate, endDate)}
            >
              Search
            </Button>
            {reportData.length > 0 && (
              <Button
                variant="outlined"
                onClick={handleSelectFirst30}
              >
                Select 30
              </Button>
            )}
          </div>
        </div>
        <div
          className={`lg:basis-3/5 lg:mt-2  p-2  flex flex-col justify-center items-center lg:flex lg:justify-center lg:items-center `}
        >
          {/* <div className={`flex mt-4   lg:basis-3/5`}> */}
          <div className="flex relative mt-4 mb-20 p-6 w-[80vw] lg:basis-4/5">
            <LineChartForNormalQT
              id="chart"
              arrData={dataAverage}
              chartName={`X-bar`}
              dataSetName={`X`}
              image={part.part_image}
              lcl={part.LCL_Xbar || 0}
              ucl={part.UCL_Xbar || 0}
              cl={part.CL_Xbar || 0}
              idQuestion={part.part_name || ""}
              partName={part.part_name || ""}
              partNo={part.part_code || ""}
              char={part.question_name || ""}
              spec={part.specCount || ""}
              min={part.spec_min || ""}
              max={part.spec_max || ""}
              torelance1={part.torelance1 || ""}
              torelance2={part.torelance2 || ""}
              dataAll={reportData}
              selectedRows={selectedRows}
              customer={part.customer || ""}
            />
          </div>
          {reportData.length > 0 ? (
            <TableReportNormalQTWithActual
              className={`mt-4`}
              data={reportData}
              headers={headers}
              selectedRows={selectedRows}
              onSelectAll={handleSelectAll}
              onSelectRow={handleSelectRow}
            />
          ) : (
            <div
              className={`text-2xl flex justify-center items-center lg:flex lg:justify-center lg:items-center `}
            >
              No data
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PerPathNormalQTWithActual;
